// src/app.ts —— H5 组合入口（TD-804 / TD-806）：createDcApp + 服务绑定
import { createDcApp, type Dict, type GpApp, type Lang } from '../../shared/src/dc';
import { readLocal } from '../../shared/src/storage';
import { DOMAINS } from './domains/index';
import { sessionImpl, totpImpl } from './domains/shell';
import { createServices, type H5Gp } from './gp';
import type { H5State } from './state';

// U-19：登录页语言 = localStorage.gpu_lang → 浏览器语言前缀 zh → 其余 en
export function initialLang(): Lang {
  const saved = readLocal('gpu_lang');
  if (saved === 'en' || saved === 'zh') return saved;
  const nav = typeof navigator !== 'undefined' ? navigator.language : '';
  return typeof nav === 'string' && nav.toLowerCase().startsWith('zh') ? 'zh' : 'en';
}

export function createH5App(opts: { dev: boolean }): GpApp<H5State> & { gp: H5Gp } {
  let dictOf: () => Dict = () => ({});
  const holder: { gp: H5Gp | null } = { gp: null };
  const app = createDcApp<H5State, H5Gp>({
    // booting 初值 true 同原型 L564（首页骨架），由 home:ready 收起（U-20）
    base: { lang: initialLang(), screen: 'login', modal: null, toast: '', toastId: 0, busy: '', booting: true, appBoot: true, sh: shellDefaults() },
    domains: DOMAINS,
    services: (events) => {
      const g = createServices(events, { session: () => sessionImpl(), totp: () => totpImpl(), dict: () => dictOf() });
      holder.gp = g;
      return g;
    },
    dev: opts.dev,
  });
  const wrapped: GpApp<H5State> = {
    ...app,
    didMount(host) {
      holder.gp?.bind(host);
      dictOf = () => app.t(host);
      app.didMount(host);
    },
  };
  if (!holder.gp) throw new Error('services 未初始化');
  return { ...wrapped, gp: holder.gp };
}

export function shellDefaults(): H5State['sh'] {
  return { config: null, botId: '', ref: '', refValid: false, miniApp: false, inTelegram: false, tgUser: '', tgId: '', profile: null, navFrom: null, termsBanner: false, totp: null };
}
